import { Component } from 'react';
import PropTypes from 'prop-types';

export async function logErrorToServer(error, info) {
  if (__DEV__) {
    console.error(error);
    console.warn(info);
  }
  try {
    const { message, stack } = error; // error is a TypeError
    const payload = JSON.stringify({ error: { message, stack }, info });

    await fetch('/api/errors', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: payload
    });
  } catch (e) {
    if (__DEV__) {
      console.error(e);
    }
    // TODO: inject origin with image
    // TODO: inject new e with image
  }
}

global.onerror = function globalOnError(message, source, lineno, colno, error) {
  logErrorToServer(error, { source, lineno, colno });
};

export default class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired
  };

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    logErrorToServer(error, info);
  }

  render() {
    // if (this.state.hasError) {
    //   // You can render any custom fallback UI
    //   return <h1>Something went wrong.</h1>;
    // }
    return this.props.children;
  }
}
